import { render, staticRenderFns } from "./CustomerDetailsTableItem.vue?vue&type=template&id=03e6bd42"
import script from "./CustomerDetailsTableItem.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports